"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.windowSize = exports.WindowSizeValue = void 0;
const tslib_1 = require("tslib");
const rsync = tslib_1.__importStar(require("./rsync"));
class WindowSizeValue extends rsync.ReactValue {
    constructor(value) {
        super(typeof window === 'object' ? [window.innerWidth, window.innerHeight] : value);
        this.onResize = () => {
            const next = [window.innerWidth, window.innerHeight];
            const prev = this.value;
            if (prev[0] !== next[0] || prev[1] !== next[1])
                this.next(next);
        };
        if (typeof window === 'object') {
            window.addEventListener('resize', this.onResize);
        }
    }
    dispose() {
        if (typeof window === 'object') {
            window.removeEventListener('resize', this.onResize);
        }
    }
}
exports.WindowSizeValue = WindowSizeValue;
const windowSize = (def = [0, 0]) => new WindowSizeValue(def);
exports.windowSize = windowSize;
